import { render, staticRenderFns } from "./SCheckbox.vue?vue&type=template&id=0f906451&scoped=true&"
import script from "./SCheckbox.vue?vue&type=script&lang=ts&"
export * from "./SCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./SCheckbox.vue?vue&type=style&index=0&id=0f906451&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f906451",
  null
  
)

export default component.exports